import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
import CovidThMap from './pages/CovidThMap.vue'
import ProjectList from './pages/ProjectList.vue'
import JetGame from './pages/JetGame.vue'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/covid19th', name: 'covid19th', component: CovidThMap },
    { path: '/projectList', name: 'projectList', component: ProjectList },
    { path: '/jetGame', name: 'jetGame', component: JetGame }
  ]
})
